// import React from 'react';
// import { Helmet } from 'react-helmet';
// import '../css/TermsConditions.css'; // Ensure this CSS file includes the new styles

// const TermsConditions = () => {
//   return (
//     <div>
//       <Helmet>
//         <title>Pune Corporate Cars India Private Limited - Terms & Conditions</title>
//         <meta name="description" content="Terms & Conditions of Pune Corporate Cars India Private Limited" />
//       </Helmet>


//  <section
//         className="breadcrumb-section"
//         style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
//       >
//         <div className="container">
//           <div className="banner-content">
//             <h1>Terms & Conditions</h1>
//           </div>
//         </div>
//       </section>

   

//       <section className="terms-section">
//         <div className="container">
//           <div className="row g-0">
//             <div className="col-md-7">
//               <div className="terms-content">
//                 <p><b className="highlight">1. Booking Confirmation:</b> All corporate bookings are subject to vehicle availability and will be confirmed once full payment is received along with issuance of a booking reference.</p>

//                 <p><b className="highlight">2. Payment:</b> Full payment must be made at the time of booking. Payments can be completed online, via bank transfer, or at our Pune office.</p>

//                 <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations and rescheduling requests are subject to our cancellation policy. Charges may apply depending on timing and type of service.</p>

//                 <p><b className="highlight">4. Passenger Responsibility:</b> Passengers must carry valid identification and corporate authorization if applicable. We reserve the right to deny service without proper documentation.</p>

//                 {/* <p><b className="highlight">5. Baggage Policy:</b> Baggage allowances depend on vehicle type. Additional baggage may incur extra charges.</p> */}

//                 <p><b className="highlight">6. Travel Insurance:</b> We recommend clients obtain travel insurance to cover unforeseen circumstances.</p>

//                 <p><b className="highlight">7. Safety Regulations:</b> Passengers must follow all safety rules and instructions given by our drivers and staff.</p>

//                 <p><b className="highlight">8. Changes to Itinerary:</b> We reserve the right to modify routes or schedules in case of traffic, operational requirements, or unforeseen events.</p>

//                 <p><b className="highlight">9. Refusal of Service:</b> Service may be refused to passengers who display disruptive behavior or violate company policies.</p>

//                 <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by Indian law, and any disputes will be subject to the jurisdiction of Pune courts.</p>

//                 <h3>General Policy</h3>
//                 <p><b className="highlight">Booking Procedure:</b> Book corporate transportation via our official website, app, or customer service desk in Pune.</p>
//                 <p><b className="highlight">Customer Service:</b> Our support team is available to assist with queries, corporate accounts, or special requests.</p>

//                 <h3>Refund Policy</h3>
//                 <p><b className="highlight">Cancellation Fees:</b> Applicable fees will be charged depending on the notice period and service type.</p>
//                 <p><b className="highlight">Refund Process:</b> Refunds will be processed to the original payment method within a reasonable timeframe.</p>
//                 <p><b className="highlight">No-Show Policy:</b> No-shows may not be eligible for a refund or rescheduling.</p>
//               </div>
//             </div>
//           </div>

//           <div className="contact-info">
//             <h2>Contact Us</h2>
//             <p>If you have any questions regarding our terms, please contact us:</p>
//             <ul>
//               <li><b>Phone:</b> <a href="tel:+919822136667">+91 9822136667</a></li>
//               <li><b>Email:</b> <a href="mailto:info@punecorporatecars.com">info@punecorporatecars.com</a></li>
//             </ul>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// };

// export default TermsConditions;



import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css';

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Pune Corporate Cars India Private Limited - Terms & Conditions</title>
        <meta
          name="description"
          content="Terms & Conditions of Pune Corporate Cars India Private Limited"
        />
      </Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Terms & Conditions</h1>
          </div>
        </div>
      </section>

      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p>
                  These Terms & Conditions govern the corporate transportation
                  and credit billing services provided by{' '}
                  <strong>Pune Corporate Cars India Private Limited</strong>.
                </p>

                <p>
                  <b className="highlight">1. Credit Facility:</b> Credit billing
                  is available only to approved corporate clients, subject to
                  submission of required documents, internal verification, and
                  management approval. The Company reserves the right to approve,
                  modify, or withdraw credit facilities at its sole discretion.
                </p>

                <p>
                  <b className="highlight">2. Credit Period:</b> The standard
                  credit period shall be 15 or 30 days from the invoice date,
                  unless otherwise agreed in writing by the Company.
                </p>

                <p>
                  <b className="highlight">3. Invoicing:</b> Invoices shall be
                  raised as per the mutually agreed billing cycle and shared
                  through the registered email address of the client. Any
                  discrepancy must be reported in writing within 3 (three)
                  working days from receipt, failing which the invoice shall be
                  deemed accepted.
                </p>

                <p>
                  <b className="highlight">4. Payment Terms:</b> All payments must
                  be made within the agreed credit period via NEFT / RTGS /
                  Cheque in favor of <strong>Pune Corporate Cars India Private Limited</strong>.
                </p>

                <p>
                  <b className="highlight">5. Late Payment:</b> Delayed payments
                  may attract interest at a rate of up to 18% per annum,
                  calculated from the due date until the date of actual payment.
                  The Company reserves the right to suspend services for accounts
                  with overdue payments.
                </p>

                <p>
                  <b className="highlight">6. Service Suspension:</b> In case of
                  non-payment or continuous delay in payments, the Company may
                  suspend services or convert the account to advance billing
                  without prior notice.
                </p>

                <p>
                  <b className="highlight">7. Disputes:</b> All billing disputes
                  must be raised in writing within 3 (three) working days of
                  invoice receipt. Undisputed invoice amounts must be paid
                  within the agreed credit period and shall not be withheld due
                  to disputes.
                </p>

                <p>
                  <b className="highlight">8. Taxes & Additional Charges:</b>{' '}
                  Applicable GST, tolls, parking charges, permits, state taxes,
                  and statutory charges shall be charged as per actuals unless
                  expressly stated otherwise.
                </p>

                <p>
                  <b className="highlight">9. Rate Revision:</b> The Company
                  reserves the right to revise rates with prior notice. Revised
                  rates shall be applicable from the communicated effective
                  date.
                </p>

                <p>
                  <b className="highlight">10. Liability:</b> The Company shall
                  not be liable for delays or service disruptions caused due to
                  traffic conditions, weather, strikes, government regulations,
                  vehicle breakdowns, or other force majeure events beyond
                  reasonable control.
                </p>

                <p>
                  <b className="highlight">11. Termination:</b> Either party may
                  terminate the credit arrangement by providing 15 (fifteen)
                  days’ written notice, subject to full and final settlement of
                  all outstanding dues.
                </p>

                <p>
                  <b className="highlight">12. Jurisdiction:</b> All disputes
                  arising out of or in connection with these terms shall be
                  subject to the exclusive jurisdiction of courts in Pune,
                  Maharashtra.
                </p>
              </div>
            </div>
          </div>

          {/* <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions regarding these Terms & Conditions:</p>
            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+919822136667">+91 9822136667</a>
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:info@punecorporatecars.com">
                  info@punecorporatecars.com
                </a>
              </li>
            </ul>
          </div> */}

{/* 
<div className="contact-info">
  <h2>Contact Us</h2>

  <h3>📞 Help Desk (24×7)</h3>
  <ul>
    <li>
      <b>Phone:</b>{' '}
      <a href="tel:+919822943334">98229 43334</a> /{' '}
      <a href="tel:+919405644855">94056 44855</a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:reservations@punecorporatecars.com">
        reservations@punecorporatecars.com
      </a>
    </li>
  </ul>

  <h3>💼 Corporate Sales (Pan India)</h3>
  <ul>
    <li>
      <b>Phone:</b>{' '}
      <a href="tel:+919822136667">98221 36667</a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:sanjay.nalawade@punecorporatecars.com">
        sanjay.nalawade@punecorporcars.com
      </a>
    </li>
  </ul>
</div> */}

<div className="contact-info">
  <h2>Contact Us</h2>

  {/* Reservations / Booking Helpdesk */}
  <h3>📞 Reservations | Booking Helpdesk (24×7)</h3>
  <ul>
    <li>
      <b>Operation Help Desk:</b>{' '}
      <a href="tel:+919822943334">+91 9822943334</a> /{' '}
      <a href="tel:+919405644855">+91 9405644855</a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:reservations@punecorporatecars.com">
        reservations@punecorporatecars.com
      </a>
    </li>
  </ul>

  {/* Corporate Sales */}
  <h3>💼 Corporate Sales (Pan India)</h3>
  <ul>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:sales@punecorporatecars.com">
        sales@punecorporatecars.com
      </a>
    </li>
    <li>
      <b>Email:</b>{' '}
      <a href="mailto:sanjay.nalawade@punecorporatecars.com">
        sanjay.nalawade@punecorporatecars.com
      </a>
    </li>
    <li>
      <b>Mobile:</b>{' '}
      <a href="tel:+919822136667">+91 9822136667</a> /{' '}
      <a href="tel:+917350959600">+91 7350959600</a>
    </li>
  </ul>
</div>


        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
